// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-report[data-v-fd0c24d4] {\n  width: 22rem;\n}\n.p-sidebar[data-v-fd0c24d4] {\n  padding: 0.3rem;\n}\n@media screen and (max-width: 960px) {\n.menu-report[data-v-fd0c24d4] {\n    width: 26%;\n}\n}\n@media screen and (max-width: 640px) {\n.menu-report[data-v-fd0c24d4] {\n    width: 35%;\n}\n}\n@media screen and (max-width: 460px) {\n.menu-report[data-v-fd0c24d4] {\n    width: 50%;\n}\n}", ""]);
// Exports
module.exports = exports;
